import React from 'react'
import { ReactComponent as Placeholder } from '../../../../../assets/img/svg/EmptyRowPlaceholder.svg';

const EmptyRowPlaceholder = () => {
  return (
    <div><Placeholder/></div>
  )
}

export default EmptyRowPlaceholder